module.exports = __webpack_public_path__ + "static/img/film.2d76aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home/film.jpg
// module id = 10jX
// module chunks = 1